export default function MessageStarIcon({
  color = '#878F9B',
  width = '20',
  height = '20',
}: {
  color?: string;
  width?: string;
  height?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.3327 18.6018C13.0493 18.6018 12.766 18.5185 12.5243 18.3602L8.97435 15.9935H5.83268C2.96602 15.9935 1.04102 14.0685 1.04102 11.2018V6.20182C1.04102 3.33516 2.96602 1.41016 5.83268 1.41016H14.166C17.0327 1.41016 18.9577 3.33516 18.9577 6.20182V11.2018C18.9577 13.8518 17.3077 15.7019 14.791 15.9602V17.1435C14.791 17.6851 14.4993 18.1768 14.0243 18.4268C13.8077 18.5435 13.566 18.6018 13.3327 18.6018ZM5.83268 2.65181C3.68268 2.65181 2.29102 4.04348 2.29102 6.19348V11.1935C2.29102 13.3435 3.68268 14.7351 5.83268 14.7351H9.16602C9.29102 14.7351 9.40768 14.7685 9.51602 14.8435L13.2243 17.3102C13.316 17.3685 13.3993 17.3435 13.441 17.3185C13.4827 17.2935 13.5493 17.2435 13.5493 17.1351V15.3601C13.5493 15.0185 13.8327 14.7351 14.1743 14.7351C16.3243 14.7351 17.716 13.3435 17.716 11.1935V6.19348C17.716 4.04348 16.3243 2.65181 14.1743 2.65181H5.83268Z'
        fill={color}
      />
      <path
        d='M9.54739 4.96419C9.72735 4.58081 10.2726 4.58081 10.4526 4.96419L11.1228 6.39177C11.1935 6.54256 11.3348 6.6482 11.4994 6.6735L13.0389 6.91011C13.441 6.97191 13.6049 7.46251 13.3207 7.75361L12.1764 8.92557C12.0655 9.03916 12.0151 9.19868 12.0406 9.35537L12.3062 10.9836C12.3734 11.3956 11.9361 11.7036 11.5708 11.5016L10.242 10.7668C10.0914 10.6836 9.9086 10.6836 9.75804 10.7668L8.42922 11.5016C8.06394 11.7036 7.62659 11.3956 7.69378 10.9836L7.95936 9.35537C7.98492 9.19868 7.93454 9.03916 7.82363 8.92557L6.67935 7.75361C6.39512 7.46251 6.55902 6.97191 6.96114 6.91011L8.50059 6.6735C8.66523 6.6482 8.80646 6.54256 8.87725 6.39177L9.54739 4.96419Z'
        stroke={color}
        stroke-width='0.75'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}
